import {
  createNewServiceCallDataDto,
  createNewServiceCallDataType,
} from './SupportDto';
import {
  SupportCategory,
  SupportEvent,
  SupportStateSupportImage,
  SupportSubCategory,
} from './SupportTypes';
import {
  REMOVE_SUPPORT_IMAGE,
  RemoveSupportImageActionType,
  SET_SUPPORT_CATEGORIES,
  SET_SUPPORT_EVENTS,
  SET_SUPPORT_EVENTS_ACTIVE_PAGE,
  SET_SUPPORT_EVENTS_COUNT_TO_SHOW,
  SET_SUPPORT_IMAGE,
  SET_SUPPORT_SUB_CATEGORIES,
  SetSupportCategoriesActionType,
  SetSupportEventsActionType,
  SetSupportEventsActivePageActionType,
  SetSupportEventsCountToShowActionType,
  setSupportImageActionType,
  SetSupportSubCategoriesActionType,
  SupportThunkAction,
  SetSupportEventsPagesActionType,
  SET_SUPPORT_EVENTS_PAGES,
} from './SupportActionTypes';
import { startLoaderThunk, stopLoaderThunk } from '../modal/modalActions';
import SupportManagementApi from '../../API/support/SupportManagement.api';

export function setSupportEventsAction(
  events: SupportEvent[]
): SetSupportEventsActionType {
  return {
    type: SET_SUPPORT_EVENTS,
    payload: events,
  };
}

export function setSupportEventsActivePageAction(
  page: number
): SetSupportEventsActivePageActionType {
  return {
    type: SET_SUPPORT_EVENTS_ACTIVE_PAGE,
    page,
  };
}

export function setSupportEventsCountToShowAction(
  count: number
): SetSupportEventsCountToShowActionType {
  return {
    type: SET_SUPPORT_EVENTS_COUNT_TO_SHOW,
    count,
  };
}

export function setSupportEventsPagesAction(
  pages: number
): SetSupportEventsPagesActionType {
  return {
    type: SET_SUPPORT_EVENTS_PAGES,
    pages,
  };
}

export function setSupportCategoriesAction(
  categories: SupportCategory[]
): SetSupportCategoriesActionType {
  return {
    type: SET_SUPPORT_CATEGORIES,
    payload: categories,
  };
}

export function removeSupportImageAction(
  index?: number
): RemoveSupportImageActionType {
  return {
    type: REMOVE_SUPPORT_IMAGE,
    index,
  };
}

export function clearSupportImage(): setSupportImageActionType {
  return {
    type: SET_SUPPORT_IMAGE,
  };
}

export function setSupportSubCategoriesAction(
  subCategories: SupportSubCategory[]
): SetSupportSubCategoriesActionType {
  return {
    type: SET_SUPPORT_SUB_CATEGORIES,
    payload: subCategories,
  };
}

export function setSupportImageAction(
  images: SupportStateSupportImage[]
): setSupportImageActionType {
  return {
    type: SET_SUPPORT_IMAGE,
    payload: images,
  };
}

export function createNewServiceCallThunk(
  data: createNewServiceCallDataType
): SupportThunkAction<Promise<number>> {
  return async (dispatch, getState) => {
    await dispatch(startLoaderThunk());
    const {
      AUTH_NAMESPACE: { profile },
    } = getState();
    const {
      SUPPORT_NAMESPACE: { supportImage },
    } = getState();

    const newData = createNewServiceCallDataDto(
      data,
      profile,
      supportImage ? supportImage?.map((image) => image.fileId) : []
    );

    try {
      const serviceCallResponse =
        await SupportManagementApi.createNewServiceCall(newData);
      return serviceCallResponse.data.id;
    } finally {
      await dispatch(stopLoaderThunk());
    }
  };
}

export function FetchSupportSubCategoriesByCategoryIdThunk(
  categoryId: number
): SupportThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    SupportManagementApi.getSupportSubCategoriesByCategoryId(categoryId)
      .then((response) => {
        dispatch(setSupportSubCategoriesAction(response.data));
      })
      .finally(() => dispatch(stopLoaderThunk()));
  };
}

export function FetchSupportCategoriesThunk(): SupportThunkAction<
  Promise<void>
> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    SupportManagementApi.getSupportCategories()
      .then((response) => {
        dispatch(setSupportCategoriesAction(response.data));
      })
      .finally(() => dispatch(stopLoaderThunk()));
  };
}

export function UploadServiceCallImageThunk(
  data: any,
  callback: any
): SupportThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    return SupportManagementApi.uploadServiceCallImage(data)
      .then(async (response) => {
        dispatch(setSupportImageAction(response.data.files));
        callback(response.data.files[0].url, null);
      })
      .catch(() => {
        callback(null, 'Something went wrong...');
      });
  };
}

export function FetchSupportEventsThunk(
  count: number,
  page: number
): SupportThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    await dispatch(startLoaderThunk());
    try {
      const response = await SupportManagementApi.getSupportEvents({
        skip: (page - 1) * count,
        take: count,
      });
      dispatch(setSupportEventsAction(response.data.events));
      dispatch(setSupportEventsPagesAction(response.data.totalPages));
      dispatch(setSupportEventsActivePageAction(page));
      dispatch(setSupportEventsCountToShowAction(count));
    } finally {
      await dispatch(stopLoaderThunk());
    }
  };
}
